import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/proceso/searchProcesos.php';

export default function searchProcesos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}